export default props => props.schema.minOcc > 0 && ["required", props.validation.required];
